import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import accounts from './accounts.reducer';
import activities from './activities.reducer';
import alerts, { alertsUiSlice } from './alerts.reducer';
import auth from './auth.reducer';
import config from './config.reducer';
import global from './global.reducer';
import inboundEmailLogs from './inboundEmailLogs.reducer';
import kpiSets from './kpiSets.reducer';
import licenses from './licenses.reducer';
import machines from './machines.reducer';
import machineClasses from './machineClasses.reducer';
import materials from './materials.reducer';
import materialClasses from './materialClasses.reducer';
import operators from './operators.reducer';
import reportDefinitions from './reportDefinitions.reducer';
import reportDefinitionParameters from './reportDefinitionParameters.reducer';
import reportRecipients from './reportRecipients.reducer';
import reportSchedules from './reportSchedules.reducer';
import scheduledJobs from './scheduledJobs.reducer';
import sites from './sites.reducer';
import registration from './registration.reducer';
import shifts from './shifts.reducer';
import truckModels from './truckModels.reducer';
import trucks from './trucks.reducer';
import users from './users.reducer';
import notificationRecipients from './notificationRecipients.reducer';
import licenseTypes from './licenseTypes.reducer';
import licenseJournals from './licenseJournals.reducer';
import manufacturers from './manufacturers.reducer';
import machineModels from './machineModels.reducer';
import kpis from './kpi.reducer';
import minePlans from './minePlan.reducer';
import machineMinePlans from './machineMinePlans.reducer';
import { importDataReducer, importEntitiesReducer } from './importData.reducer';
import {
  efePaginationSlice,
  efeSlice,
  efeUiSlice,
} from './edgeFileExportReducer';
import {
  materialPaginationSlice,
  materialSlice,
  materialUiSlice,
} from './materials.reducer.v2';
import { materialClassUiSlice } from './materialClasses.reducer.v2';

const entitiesReducer = combineReducers({
  accounts,
  activities,
  alerts,
  auth,
  config,
  global,
  inboundEmailLogs,
  kpis,
  kpiSets,
  licenseJournals,
  licenses,
  licenseTypes,
  machines,
  machineClasses,
  machineModels,
  manufacturers,
  materials,
  materialClasses,
  oidc: oidcReducer,
  operators,
  registration,
  reportDefinitions,
  reportDefinitionParameters,
  reportRecipients,
  reportSchedules,
  scheduledJobs,
  sites,
  shifts,
  trucks,
  truckModels,
  users,
  notificationRecipients,
  minePlans,
  machineMinePlans,
  importData: importDataReducer,
  importEntities: importEntitiesReducer,
  [efeSlice.name]: efeSlice.reducer,
  [materialSlice.name]: materialSlice.reducer,
});

export default entitiesReducer;

/**
 * Defines a reducer to cache paged data.
 */
export const paginationReducer = combineReducers({
  [efePaginationSlice.name]: efePaginationSlice.reducer,
  [materialPaginationSlice.name]: materialPaginationSlice.reducer,
});

/**
 * Defines a reducer to cache ui states.
 */
const uiReducer = combineReducers({
  [efeUiSlice.name]: efeUiSlice.reducer,
  [materialUiSlice.name]: materialUiSlice.reducer,
  [materialClassUiSlice.name]: materialClassUiSlice.reducer,
  [alertsUiSlice.name]: alertsUiSlice.reducer,
});

/**
 * @name uiStateConstants
 */
export const uiStateConstants = {
  RESET_UI_STATE: 'RESET_UI_STATE',
};

/**
 * To construct the ui state reducer.
 * @param {StoreState} state redux store state
 * @param {Action} action
 * @returns Ui state reducer
 */
export const uiStateReducer = (state, action) => {
  if (action.type === uiStateConstants.RESET_UI_STATE) {
    return uiReducer(undefined, action);
  }
  return uiReducer(state, action);
};
